/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Clubs_Days_OptionInputs */

const en_us2_clubs_days_option = /** @type {(inputs: Clubs_Days_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} days`)
};

const pt_br2_clubs_days_option = /** @type {(inputs: Clubs_Days_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dias`)
};

const es_419_clubs_days_option = /** @type {(inputs: Clubs_Days_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} días`)
};

const pt_pt2_clubs_days_option = /** @type {(inputs: Clubs_Days_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dias`)
};

const fr_fr2_clubs_days_option = /** @type {(inputs: Clubs_Days_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} jours`)
};

const de_de2_clubs_days_option = /** @type {(inputs: Clubs_Days_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} Tage`)
};

const it_it2_clubs_days_option = /** @type {(inputs: Clubs_Days_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} giorni`)
};

/**
* | output |
* | --- |
* | "{days} days" |
*
* @param {Clubs_Days_OptionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_days_option = /** @type {((inputs: Clubs_Days_OptionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Days_OptionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_days_option(inputs)
	if (locale === "es-419") return es_419_clubs_days_option(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_days_option(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_days_option(inputs)
	if (locale === "de-DE") return de_de2_clubs_days_option(inputs)
	if (locale === "it-IT") return it_it2_clubs_days_option(inputs)
	return en_us2_clubs_days_option(inputs)
});
export { clubs_days_option as "clubs.days_option" }